import base64url from 'base64url';

const CryptoJS = require('crypto-js');

export const generateOGAuthorization = (id: string, storefrontApiKey: string, merchantId: string | undefined) => {
    const ts = Math.floor(Date.now() / 1000);
    const hash = CryptoJS.HmacSHA256(`${id}|recognized|${ts}`, base64url.decode(storefrontApiKey));
    const sig = CryptoJS.enc.Base64.stringify(hash);
    return JSON.stringify({
        public_id: merchantId,
        sig_field: id,
        ts,
        sig,
        trust_level: 'recognized',
    });
};
